var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:(_vm.$slots.default[0].text),expression:"$slots.default[0].text",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"ml-2"}},[_c('i',{staticClass:"fa fa-info-circle text-dark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }